import React, { createContext, useReducer } from "react";
import { configContext, configInterface } from "./initialState/Config";
import { memberContext, memberContextInterface } from "./initialState/Member";
import {
  providerContext,
  providerContextInterface
} from "./initialState/Provider";
import {
  readingContext,
  ReadingContextInterface
} from "./initialState/Readings";
import {
  thresholdContext,
  ThresholdContextInterface
} from "./initialState/Threshold";
import {
  notificationsContext,
  notificationsContextInterface
} from "./initialState/Notifications";
import { devicesContext, DeviceContextInterface } from "./initialState/Devices";
import {
  encounterContext,
  EncounterContextInterface
} from "./initialState/Encounter";
import { notesContext, NotesContextInterface } from "./initialState/Notes";
import { encounterTimerContext, EncounterTimerContextInterface} from "./initialState/EncounterTimer";
import { settingsContext, SettingsContextInterface } from "./initialState/Settings";

import configReducer from "./reducers/configReducer";
import memberReducer from "./reducers/memberReducer";
import readingsReducer from "./reducers/readingsReducer";
import providerReducer from "./reducers/providerReducer";
import thresholdReducer from "./reducers/thresholdReducer";
import notesReducer from "./reducers/notesReducer";
import notificationsReducer from "./reducers/notificationsReducer";
import encounterReducer from "./reducers/encounterReducer";
import devicesReducer from "./reducers/devicesReducer";
import encounterTimerReducer from "./reducers/encounterTimerReducer";
import settingsReducer from "./reducers/settingsReducer";

export interface GlobalContextInterface {
  config?: configInterface;
  member?: memberContextInterface;
  provider?: providerContextInterface;
  readings?: ReadingContextInterface;
  threshold?: ThresholdContextInterface;
  notifications?: notificationsContextInterface;
  notes?: NotesContextInterface;
  encounters?: EncounterContextInterface;
  devices?: DeviceContextInterface;
  encounterTimer?: EncounterTimerContextInterface;
  settings?: SettingsContextInterface;

  configDispatch?: any;
  memberDispatch?: any;
  providerDispatch?: any;
  readingsDispatch?: any;
  thresholdDispatch?: any;
  notificationsDispatch?: any;
  notesDispatch?: any;
  encounterDispatch?: any;
  devicesDispatch?: any;
  encounterTimerDispatch?: any;
  settingsDispatch?: any;
}

interface GlobalProviderProps {
  children: JSX.Element;
}

export const GlobalContext = createContext<GlobalContextInterface>({});

const GlobalProvider: React.FC<GlobalProviderProps> = ({ children }) => {
  const [config, configDispatch] = useReducer(configReducer, configContext);
  const [member, memberDispatch] = useReducer(memberReducer, memberContext);
  const [readings, readingsDispatch] = useReducer(
    readingsReducer,
    readingContext
  );
  const [provider, providerDispatch] = useReducer(
    providerReducer,
    providerContext
  );
  const [threshold, thresholdDispatch] = useReducer(
    thresholdReducer,
    thresholdContext
  );
  const [notifications, notificationsDispatch] = useReducer(
    notificationsReducer,
    notificationsContext
  );
  const [notes, notesDispatch] = useReducer(notesReducer, notesContext);
  const [encounters, encounterDispatch] = useReducer(
    encounterReducer,
    encounterContext
  );
  const [devices, devicesDispatch] = useReducer(devicesReducer, devicesContext);
  const [encounterTimer, encounterTimerDispatch] = useReducer(encounterTimerReducer, encounterTimerContext);
  const [settings, settingsDispatch] = useReducer(settingsReducer, settingsContext);

  return (
    <GlobalContext.Provider
      value={{
        config,
        member,
        provider,
        readings,
        threshold,
        notifications,
        notes,
        encounters,
        devices,
        encounterTimer,
        settings,
        configDispatch,
        memberDispatch,
        providerDispatch,
        readingsDispatch,
        thresholdDispatch,
        notificationsDispatch,
        notesDispatch,
        encounterDispatch,
        devicesDispatch,
        encounterTimerDispatch,
        settingsDispatch
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export default GlobalProvider;
